(function() {
  'use strict';

  var drag = { isDragging: false, startX: 0, scrollLeft: 0, moved: false, slider: null };

  function init() {
    var containers = document.querySelectorAll('[data-cart-empty-recommendations]');
    if (!containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      initContainer(containers[i]);
    }
  }

  function initContainer(container) {
    if (container.getAttribute('data-cec-initialized') === 'true') return;
    container.setAttribute('data-cec-initialized', 'true');

    container.addEventListener('click', onClick);
    container.addEventListener('change', onVariantChange);

    var slider = container.querySelector('.upsell-recommendations__slider');
    if (slider) {
      slider.addEventListener('mousedown', onDragStart);
      slider.addEventListener('scroll', function() {
        updateDots(container);
      });
    }
  }

  function updateDots(container) {
    var slider = container.querySelector('.upsell-recommendations__slider');
    var dots = container.querySelectorAll('.upsell-recommendations__dot');
    if (!slider || !dots.length) return;

    var products = slider.querySelectorAll('.upsell-product');
    if (!products.length) return;

    var scrollLeft = slider.scrollLeft;
    var activeIndex = 0;

    for (var i = 0; i < products.length; i++) {
      if (Math.abs(products[i].offsetLeft - scrollLeft) < Math.abs(products[activeIndex].offsetLeft - scrollLeft)) {
        activeIndex = i;
      }
    }

    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-active', j === activeIndex);
    }
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    var theme = window.theme;
    if (theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function onClick(e) {
    if (drag.moved) {
      e.preventDefault();
      return;
    }

    var dot = e.target.closest('.upsell-recommendations__dot');
    if (dot) {
      e.preventDefault();
      var container = dot.closest('[data-cart-empty-recommendations]');
      var slider = container && container.querySelector('.upsell-recommendations__slider');
      var index = parseInt(dot.dataset.index, 10);
      if (slider) {
        var products = slider.querySelectorAll('.upsell-product');
        if (products[index]) {
          products[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }
      return;
    }

    var addBtn = e.target.closest('.upsell-product__add-btn');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addToCart(addBtn);
    }
  }

  function onVariantChange(e) {
    if (!e.target.classList.contains('upsell-product__variant-select')) return;
    var select = e.target;
    var productEl = select.closest('.upsell-product');
    var addBtn = productEl.querySelector('.upsell-product__add-btn');
    var priceEl = productEl.querySelector('.upsell-product__price');
    var imageEl = productEl.querySelector('.upsell-product__image');

    var selectedOption = select.options[select.selectedIndex];

    if (addBtn) {
      addBtn.setAttribute('data-variant-id', selectedOption.value);
    }

    if (priceEl && selectedOption) {
      var price = selectedOption.dataset.price;
      var comparePrice = selectedOption.dataset.comparePrice;

      if (comparePrice && parseInt(comparePrice, 10) > parseInt(price, 10)) {
        priceEl.innerHTML = '<span class="upsell-product__price--sale">' + formatMoney(price) + '</span> '
          + '<span class="upsell-product__price--compare">' + formatMoney(comparePrice) + '</span>';
      } else {
        priceEl.textContent = formatMoney(price);
      }
    }

    if (imageEl && selectedOption && selectedOption.dataset.image) {
      imageEl.src = selectedOption.dataset.image;
    }
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    setButtonLoading(btn, true);

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(err) {
          throw err;
        });
      }
      return response.json();
    })
    .then(function(data) {
      setButtonLoading(btn, false);
      showToast('Added to cart', 'success');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        // Preserve the actual entry and submitted quantity for independent analytics.
        detail: { product: data, addToCartBtn: btn, quantity: 1, source: 'empty_cart_recommendations' }
      }));
      if (document.body.classList.contains('template-cart')) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    })
    .catch(function(error) {
      setButtonLoading(btn, false);
      showToast(error.description || error.message || 'Failed to add to cart', 'error');
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: error.description || error.message || 'Failed to add to cart' }
      }));
    });
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    var textEl = btn.querySelector('.upsell-product__add-btn-text');
    var loadEl = btn.querySelector('.upsell-product__add-btn-loading');

    if (loading) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (textEl) textEl.style.display = 'none';
      if (loadEl) loadEl.style.display = 'inline-flex';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      if (textEl) textEl.style.display = '';
      if (loadEl) loadEl.style.display = 'none';
    }
  }

  function showToast(message, type) {
    var existing = document.querySelector('.upsell-toast');
    if (existing) existing.parentNode.removeChild(existing);

    var toast = document.createElement('div');
    toast.className = 'upsell-toast upsell-toast--' + (type || 'info');

    var icon = '';
    if (type === 'success') {
      icon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:8px">'
        + '<polyline points="20 6 9 17 4 12"/></svg>';
    }
    toast.innerHTML = icon + message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, type === 'error' ? 3000 : 2000);
  }

  function onDragStart(e) {
    if (e.target.closest('select, button')) return;
    e.preventDefault();
    var slider = e.currentTarget;
    drag.isDragging = true;
    drag.moved = false;
    drag.slider = slider;
    drag.startX = e.pageX;
    drag.scrollLeft = slider.scrollLeft;
    slider.style.cursor = 'grabbing';
    slider.style.userSelect = 'none';
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
  }

  function onDragMove(e) {
    if (!drag.isDragging || !drag.slider) return;
    e.preventDefault();
    var x = e.pageX - drag.startX;
    if (Math.abs(x) > 5) drag.moved = true;
    drag.slider.scrollLeft = drag.scrollLeft - x;
  }

  function onDragEnd() {
    if (!drag.isDragging) return;
    drag.isDragging = false;
    var slider = drag.slider;
    if (slider) {
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
      slider.style.scrollBehavior = '';
      slider.style.scrollSnapType = '';
    }
    drag.slider = null;
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    setTimeout(function() { drag.moved = false; }, 10);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
